import { Country, getCountryCode } from "../helpers/LocationHelpers";
import { LIBYA_GOVERNANTES, TN_GOVERNANTES } from "./data/Governantes";

export const CONSTANTS = {
  STRINGS: {
    RESPONSE_ERROR: "Response status: ",
    INVALID_CREDENTIALS: "Invalid credentials",
    EMAIL_NOT_FOUND: "Email not found",
    SUCCESS: "Success",
    REALTIME_CONNECTION_OPENED: "Realtime connection opened",
    REALTIME_CONNECTION_CLOSED: "Realtime connection closed",
  },

  GO_TO_COLLECTION: "mg",
  ADD_COLLECTION_TO_ACTION: "add_collection_to_action",

  GOVERNORATES:
    getCountryCode() === Country.TUNISIA ? TN_GOVERNANTES : LIBYA_GOVERNANTES,

  EXPORTED_PRODUCT_CSV_FILE_NAME: `products-${new Date().toISOString().split("T")[0]}.csv`,
  EXPORTED_PRODUCT_PDF_FILE_NAME: `products-${new Date().toISOString().split("T")[0]}.pdf`,

  EXPORTED_ORDER_CSV_FILE_NAME: `orders-${new Date().toISOString().split("T")[0]}.csv`,
  EXPORTED_ORDER_PDF_FILE_NAME: `orders-${new Date().toISOString().split("T")[0]}.pdf`,
};







